// extracted by mini-css-extract-plugin
module.exports = {"marker":"style_marker__2r8-a","legend":"style_legend__37CIx","legendItem":"style_legendItem__22T6B"};